import { render } from "./PanelNoAccess.vue?vue&type=template&id=72ee2f7b&ts=true"
import script from "./PanelNoAccess.vue?vue&type=script&lang=ts"
export * from "./PanelNoAccess.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__